import React from 'react';
import styles from './EmojiButton.module.css';

const EmojiButton = ({ emoji, isSelected, onClick }) => {
    return (
        <button
            className={`${styles.button} ${isSelected ? styles.selected : ''}`}
            onClick={onClick}
        >
            {emoji}
        </button>
    );
};

export default EmojiButton;
